<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full"> اقلام مصرفی </span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 bodyItem" no-gutters>
      <v-col cols="12">
        <v-row class="ma-0">
          <span>اقلام مصرفی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="ma-0">
          <v-col cols="4">
            <v-autocomplete ref="medicalItemAutocomplete" :items="allMedicalItemsForOther"
              no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title" item-value="id" label="اقلام مصرفی"
              clearable clear-icon="mdi-close-circle-outline" v-model="patientMedicalItem.medicalItemId"
              autocomplete="off" prepend-inner-icon="mdi-needle mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field dense outlined label="تعداد" clearable @keypress="isNumber($event)" type="number"
              @keydown.enter="pressEnterCount()" clear-icon="mdi-close-circle-outline"
              v-model="patientMedicalItem.count" prepend-inner-icon="mdi-needle mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-spacer></v-spacer>
              <v-btn rounded text class="set-btn px-9 mt-3" @click="addMedicalItemUsage()">
                ثبت
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="ma-0">
          <span>اقلام مصرفی انتخابی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="ma-0">
          <v-col cols="12" class="drug-uses-part">
            <v-row>
              <v-col cols="6" v-for="item in allUsesMedicalItems" :key="item.id">
                <v-card elevation="0">
                  <v-card-text>
                    <v-row>
                      <v-col class="data-part">
                        <v-row>
                          <v-col cols="3">
                            <v-row>
                              <span class="data-part-title mr-2 mt-3">{{ item.medicalItem }}</span>
                              <span class="mr-2 mt-3 data-part-count">
                                ( {{ item.count }} عدد )
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="action-part">
                        <v-row>
                          <v-spacer></v-spacer>
                          <v-icon color="white" class="mt-3 mb-3" @click="deletePatientMedicalItemFunction(item.id)">
                            mdi-delete mdi-18px
                          </v-icon>
                          <v-spacer></v-spacer>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 mt-2">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">بعدی (توضیحات و نتیجه)</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">بستن</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep13Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep13Helper.js';
import MedicalItemMixin from '@/Mixins/BaseInformation/MedicalItemMixin';
import ShearedMixin from '@/Mixins/Shared.js';
import SharedHelper from '@/Helpers/Shared';
import PatientMedicalItemMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientMedicalItemMixin.js';
export default {
  mixins: [
    FollowUpPatientStep13Helper,
    MedicalItemMixin,
    ShearedMixin,
    SharedHelper,
    PatientMedicalItemMixin,
  ],
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getListOfMedicalItemsForOther();
      this.getAllPatientMedicalItemFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      this.$emit('goToNextDialog');
    },
    pressEnterCount() {
      this.addMedicalItemUsage()
      this.$nextTick(() => {
        this.$refs.medicalItemAutocomplete?.focus();
      });
    },
  },
};
</script>
<style scoped>
.bodyItem {
  max-height: 575px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.drug-uses-part {
  height: 35vh;
  overflow-y: auto;
}

.set-btn {
  background: var(--background-color) !important;
  color: var(--dark-color) !important;
  letter-spacing: normal;
  border: 1px solid var(--dark-color) !important;
}

.action-part {
  width: 6%;
  max-width: 6%;
  min-width: 6%;
  background: var(--dark-color) !important;
  border-top-left-radius: 7px !important;
  border-bottom-left-radius: 7px !important;
}

.data-part {
  width: 94%;
  max-width: 94%;
  min-width: 94%;
  background: var(--background-color) !important;
  border-top-right-radius: 7px !important;
  border-bottom-right-radius: 7px !important;
}

.data-part-title {
  font-weight: 600;
  font-size: 14px;
  color: #212121;
}

.data-part-count {
  font-size: 12px;
}
</style>
